import styled, { css } from 'styled-components';

import { RemoteBrandMark28 } from 'remote-com-shared/components/Brand/Logo';

import { tabletBreakpoint } from '@/src/domains/shared/breakpoints';

const RemoteBrandLogo = styled(RemoteBrandMark28)`
  ${tabletBreakpoint(css`
    display: none;
  `)}
`;

export default RemoteBrandLogo;
